export function getMaxxSemanticActions({ isMobile = false } = {}) {
  const actions = [
    {
      id: "pause_neurons",
      action: "n2x_pause",
      label: "Pause neurons",
      trigger: "voice_or_pointer",
      expectedEffect: isMobile
        ? "Pause the neuron sequence."
        : "Pause the neuron sequence and reveal the Neurodesign layer.",
      expectedEffectTypes: isMobile
        ? ["pause_neurons"]
        : ["pause_neurons", "reveal_neurodesign"],
      targetId: isMobile ? "maxx_neurons" : "maxx_neurodesign",
    },
    {
      id: "resume_neurons",
      action: "n2x_resume",
      label: "Resume neurons",
      trigger: "voice",
      expectedEffect: "Resume the neuron sequence and hide the Neurodesign layer.",
      expectedEffectTypes: ["resume_neurons", "hide_neurodesign"],
      targetId: "maxx_neurons",
    },
    {
      id: "back_to_root",
      action: "back",
      label: "Return to Moon",
      trigger: "voice_or_pointer",
      expectedEffect: "Leave the Exocortex and return to the Moon orientation space.",
      expectedEffectTypes: ["navigate_root"],
      targetId: "root",
    },
  ];

  if (isMobile) {
    actions.splice(2, 0, {
      id: "launch_n2x_ar",
      action: "launch_in_space_n2x",
      label: "Open neuron AR",
      trigger: "voice_or_pointer",
      expectedEffect: "Open the camera and place the neuron experience in physical space.",
      expectedEffectTypes: ["launch_ar"],
      targetId: "maxx_neurons",
    });
  }

  return actions;
}

export function getMaxxSemanticAction(actionId, options = {}) {
  const normalized = String(actionId || "").toLowerCase();
  return getMaxxSemanticActions(options).find(
    (action) => action.id === normalized || action.action === normalized
  ) || null;
}
